import { SplitApiSettings } from "./SplitApiSetting";
import { API_END_POINTS } from "./ApiEndpoints";

export const api = SplitApiSettings.injectEndpoints({
  reducerPath: "api",
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    /////////////////////////////<===MUTATIONS===>//////////////////////////////
    registerBusinessForm: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.registerBusinessForm,
        method: "POST",
        body: data,
      }),
    }),
    contactForm: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.contactForm,
        method: "POST",
        body: data,
      }),
    }),
        loginUser: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.loginUser,
        method: "POST",
        body: data,
      }),
    }),
    registerUser: builder.mutation({
      query: (data) => ({
        url: API_END_POINTS.registerUser,
        method: "POST",
        body: data,
      }),
    }),
  }),

    /////////////////////////////<===QUERIES===>////////////////////////////////

    // getPackages: builder.query({
    //   query: () => {
    //     return {
    //       url: API_END_POINTS.getPackages,
    //       method: "GET",
    //     };
    //   },
    // }),



  overrideExisting: true,
});

export const {
  /////////////////////////////<===MUTATIONS===>//////////////////////////////
  useRegisterBusinessFormMutation,
  useContactFormMutation,
  useRegisterUserMutation,
  useLoginUserMutation,
  /////////////////////////////<===QUERIES===>////////////////////////////////
  // useGetPackagesQuery,
} = api;
